export enum CustomerType {
  PRIVATE_CUSTOMER = 0,
  INSURED_CUSTOMER = 1
}